const content = (
  <div>
    <p>
      Cette formation vous fournira toutes les clés pour définir et affirmer
      votre posture de manager. Elle permet de valoriser l’autonomie des
      collaborateurs, de susciter l’engagement de l’équipe et de gérer
      efficacement les conflits.
    </p>
    <h2>Public Concerné</h2>
    <p>Managers d’équipe en poste ou futurs managers.</p>
    <h2>Prérequis</h2>
    <p>Aucun</p>
    <h2>Objectifs pédagogiques</h2>
    <ul>
      <li>
        Identifier son rôle et ses responsabilités de manager de proximité
      </li>
      <li>Adapter son style de management aux situations</li>
      <li>Impliquer les collaborateurs et obtenir l’adhésion</li>
      <li>Développer l’autonomie pour motiver son équipe</li>
      <li>Gérer les situations delicates</li>
    </ul>

    <h2>Dates et Durée</h2>
    <ul>
      <li>Dates : Définies selon planning</li>
      <li>
        Durée : 2 jours de 9h00 à 17h30 soit 7,5 heures effectives de formation
        par jour.
      </li>
    </ul>
    <h2>Organisation</h2>
    <p>À distance, avec ou sans regroupements, ou en partie en présentiel.</p>
    <p>En intra ou inter entreprise.</p>
    <h2>Taille du groupe</h2>
    <p>Jusqu’à 10 stagiaires.</p>
    <h2>Lieux</h2>
    <p>En intra : Chez le client</p>
    <p>En inter : Des salles de formation sont proposées à Paris.</p>
    <h2>Accessibilité</h2>
    <p>
      Pour toute situation de handicap merci de nous contacter pour envisager la
      faisabilité.
    </p>
    <h2>Délai et modalités d'accès</h2>
    <p>
      Jusqu'à 48h avant le début de la formation et en fonction des plannings.
    </p>
    <h2>Tarifs</h2>
    <p>1.200 Euros hors taxes pour les 2 jours de formation par stagiaire.</p>

    <h2>Programme de la formation</h2>
    <h3>1/ Les rôles et les missions du manager de proximité</h3>
    <ul>
      <li>
        Connaître et assumer les responsabilités du manager, ses objectifs et
        ses missions au quotidien
      </li>
      <li>
        Différencier les compétences techniques des compétences managériales
      </li>
      <li>
        Comprendre l’importance du facteur humain dans la gestion d’équipe
      </li>
      <li>Identifier sa plus-value dans les processus de l’entreprise</li>
    </ul>
    <h3>2/ Pouvoir du manager de proximité</h3>
    <ul>
      <li>Identifier les différentes sources de pouvoir et leurs limites</li>
      <li>Développer son leadership en équilibrant fermeté et souplesse</li>
      <li>
        Comprendre les jeux de pouvoir pour renforcer les relations de travail
      </li>
      <li>Favoriser la confiance mutuelle et l’adhésion aux projets</li>
    </ul>
    <h3>3/ Les comportements efficaces : le management situationnel</h3>
    <ul>
      <li>Identifier son style de management et l’adapter</li>
      <li>Gérer les dynamiques individuelles et collectives</li>
      <li>Utiliser différents styles selon les situations</li>
    </ul>
    <h3>4/ Développer l’autonomie des collaborateurs</h3>
    <ul>
      <li>Utiliser l’empathie pour comprendre la vision du collaborateur</li>
      <li>Pratiquer l’écoute active et le questionnement</li>
      <li>Adapter l’argumentaire à chaque profil</li>
      <li>Traiter les objections avec la méthode DESC</li>
    </ul>

    <h3>5/ Reconnaître les réussites pour encourager</h3>
    <ul>
      <li>Identifier les réussites individuelles et collectives</li>
      <li>Agir sur la spirale de la réussite</li>
      <li>Utiliser des signes de reconnaissance pertinents</li>
      <li>Développer la motivation des collaborateurs</li>
    </ul>
    <h3>6/ Gérer les situations difficiles</h3>
    <ul>
      <li>Identifier les conflits et comprendre leur origine</li>
      <li>Gérer ses émotions en situation tendue</li>
      <li>Maîtriser les étapes de résolution de conflit</li>
    </ul>
    <h2>Méthodes pédagogiques</h2>
    <p>
      Pédagogie active basée sur l’expérimentation : jeux de rôles, mises en
      situation, autodiagnostics, cas pratiques.
    </p>
    <h2>Modalités d’évaluation</h2>
    <p>
      Évaluation continue par le formateur (QCM, mises en situation, travaux
      pratiques) + auto-évaluation avant et après la formation.
    </p>
  </div>
);

export default content;
